import {
    ComplectationCreateForm,
    ComplectationOptionsCreateForm,
} from '@/types/complectation/complectation-create-form.type.ts';

export type ComplectationOptionsUICreateForm = {
    abs: boolean,
    all_round_camera: boolean,
    auto_parking_system: boolean,
    aux: boolean,
    blind_spot_monitoring: boolean,
    bluetooth: boolean,
    central_locking: boolean,
    climate?: string,
    collision_avoidance_system: boolean,
    combination_skin: boolean,
    conditioner?: boolean,
    cruise_control: boolean,
    driver_knee_airbag: boolean,
    driver_tracking_system: boolean,
    ebd: boolean,
    electric_driver_seat: boolean,
    electric_passenger_seat: boolean,
    emergency_brake_assist: boolean,
    fog_lights: boolean,
    front_airbags: boolean,
    front_parking_sensors: boolean,
    glonass: boolean,
    hac: boolean,
    headlight_washer: boolean,
    headlights?: string,
    heated_seats: boolean,
    heated_wheel: boolean,
    hold_lane_assist: boolean,
    immobilizer: boolean,
    interiortype?: string,
    isofix: boolean,
    leather_gearshift: boolean,
    leather_wheel: boolean,
    light_sensor: boolean,
    memory_settings: boolean,
    multifunction_steering_wheel: boolean,
    native_navigation_system: boolean,
    number_seats?: string,
    panoramic_roof: boolean,
    part_folding_baskrest: boolean,
    power_heated_mirrors: boolean,
    power_tailgate: boolean,
    power_windows: boolean,
    rain_sensor: boolean,
    rear_door_lock: boolean,
    rear_parking_sensors: boolean,
    rear_view_camera: boolean,
    roof_rails: boolean,
    running_lights: boolean,
    safety_shutters: boolean,
    seat_ventilation: boolean,
    side_airbags: boolean,
    signalling: boolean,
    smart_key: boolean,
    socket_12v: boolean,
    socket_220v: boolean,
    steering_wheel?: string,
    tcs: boolean,
    tire_pressure_monitoring: boolean,
    usb: boolean,
    wheels_material?: string,
    wheels_size?: string,
};

export type ComplectationUICreateForm = {
    model_id?: number,
    code: string,
    complectation_option: ComplectationOptionsUICreateForm,
};

export function makeComplectationOptionsEmptyUICreateForm(): ComplectationOptionsUICreateForm {
    return {
        abs: false,
        all_round_camera: false,
        auto_parking_system: false,
        aux: false,
        blind_spot_monitoring: false,
        bluetooth: false,
        central_locking: false,
        climate: undefined,
        collision_avoidance_system: false,
        combination_skin: false,
        conditioner: undefined,
        cruise_control: false,
        driver_knee_airbag: false,
        driver_tracking_system: false,
        ebd: false,
        electric_driver_seat: false,
        electric_passenger_seat: false,
        emergency_brake_assist: false,
        fog_lights: false,
        front_airbags: false,
        front_parking_sensors: false,
        glonass: false,
        hac: false,
        headlight_washer: false,
        headlights: undefined,
        heated_seats: false,
        heated_wheel: false,
        hold_lane_assist: false,
        immobilizer: false,
        interiortype: undefined,
        isofix: false,
        leather_gearshift: false,
        leather_wheel: false,
        light_sensor: false,
        memory_settings: false,
        multifunction_steering_wheel: false,
        native_navigation_system: false,
        number_seats: undefined,
        panoramic_roof: false,
        part_folding_baskrest: false,
        power_heated_mirrors: false,
        power_tailgate: false,
        power_windows: false,
        rain_sensor: false,
        rear_door_lock: false,
        rear_parking_sensors: false,
        rear_view_camera: false,
        roof_rails: false,
        running_lights: false,
        safety_shutters: false,
        seat_ventilation: false,
        side_airbags: false,
        signalling: false,
        smart_key: false,
        socket_12v: false,
        socket_220v: false,
        steering_wheel: undefined,
        tcs: false,
        tire_pressure_monitoring: false,
        usb: false,
        wheels_material: undefined,
        wheels_size: undefined,
    };
}

export function makeComplectationEmptyUICreateForm(): ComplectationUICreateForm {
    return {
        model_id: undefined,
        code: '',
        complectation_option: makeComplectationOptionsEmptyUICreateForm(),
    };
}

export function mapComplectationOptionsUICreateFormToRequestCreateForm(uiCreateForm: ComplectationOptionsUICreateForm): ComplectationOptionsCreateForm {
    const createForm: ComplectationOptionsCreateForm = {};

    if (uiCreateForm.abs) {
        createForm.abs = 'yes';
    }

    if (uiCreateForm.all_round_camera) {
        createForm.all_round_camera = 'yes';
    }

    if (uiCreateForm.auto_parking_system) {
        createForm.auto_parking_system = 'yes';
    }

    if (uiCreateForm.aux) {
        createForm.aux = 'yes';
    }

    if (uiCreateForm.blind_spot_monitoring) {
        createForm.blind_spot_monitoring = 'yes';
    }

    if (uiCreateForm.bluetooth) {
        createForm.bluetooth = 'yes';
    }

    if (uiCreateForm.central_locking) {
        createForm.central_locking = 'yes';
    }

    if (uiCreateForm.climate !== undefined) {
        createForm.climate = uiCreateForm.climate;
    }

    if (uiCreateForm.collision_avoidance_system) {
        createForm.collision_avoidance_system = 'yes';
    }

    if (uiCreateForm.combination_skin) {
        createForm.combination_skin = 'yes';
    }

    if (uiCreateForm.conditioner) {
        createForm.conditioner = 'yes';
    }

    if (uiCreateForm.cruise_control) {
        createForm.cruise_control = 'yes';
    }

    if (uiCreateForm.driver_knee_airbag) {
        createForm.driver_knee_airbag = 'yes';
    }

    if (uiCreateForm.driver_tracking_system) {
        createForm.driver_tracking_system = 'yes';
    }

    if (uiCreateForm.ebd) {
        createForm.ebd = 'yes';
    }

    if (uiCreateForm.electric_driver_seat) {
        createForm.electric_driver_seat = 'yes';
    }

    if (uiCreateForm.electric_passenger_seat) {
        createForm.electric_passenger_seat = 'yes';
    }

    if (uiCreateForm.emergency_brake_assist) {
        createForm.emergency_brake_assist = 'yes';
    }

    if (uiCreateForm.fog_lights) {
        createForm.fog_lights = 'yes';
    }

    if (uiCreateForm.front_airbags) {
        createForm.front_airbags = 'yes';
    }

    if (uiCreateForm.front_parking_sensors) {
        createForm.front_parking_sensors = 'yes';
    }

    if (uiCreateForm.glonass) {
        createForm.glonass = 'yes';
    }

    if (uiCreateForm.hac) {
        createForm.hac = 'yes';
    }

    if (uiCreateForm.headlight_washer) {
        createForm.headlight_washer = 'yes';
    }

    if (uiCreateForm.headlights !== undefined) {
        createForm.headlights = uiCreateForm.headlights;
    }

    if (uiCreateForm.heated_seats) {
        createForm.heated_seats = 'yes';
    }

    if (uiCreateForm.heated_wheel) {
        createForm.heated_wheel = 'yes';
    }

    if (uiCreateForm.hold_lane_assist) {
        createForm.hold_lane_assist = 'yes';
    }

    if (uiCreateForm.immobilizer) {
        createForm.immobilizer = 'yes';
    }

    if (uiCreateForm.interiortype !== undefined) {
        createForm.interiortype = uiCreateForm.interiortype;
    }

    if (uiCreateForm.isofix) {
        createForm.isofix = 'yes';
    }

    if (uiCreateForm.leather_gearshift) {
        createForm.leather_gearshift = 'yes';
    }

    if (uiCreateForm.leather_wheel) {
        createForm.leather_wheel = 'yes';
    }

    if (uiCreateForm.light_sensor) {
        createForm.light_sensor = 'yes';
    }

    if (uiCreateForm.memory_settings) {
        createForm.memory_settings = 'yes';
    }

    if (uiCreateForm.multifunction_steering_wheel) {
        createForm.multifunction_steering_wheel = 'yes';
    }

    if (uiCreateForm.native_navigation_system) {
        createForm.native_navigation_system = 'yes';
    }

    if (uiCreateForm.number_seats !== undefined) {
        createForm.number_seats = uiCreateForm.number_seats;
    }

    if (uiCreateForm.panoramic_roof) {
        createForm.panoramic_roof = 'yes';
    }

    if (uiCreateForm.part_folding_baskrest) {
        createForm.part_folding_baskrest = 'yes';
    }

    if (uiCreateForm.power_heated_mirrors) {
        createForm.power_heated_mirrors = 'yes';
    }

    if (uiCreateForm.power_tailgate) {
        createForm.power_tailgate = 'yes';
    }

    if (uiCreateForm.power_windows) {
        createForm.power_windows = 'yes';
    }

    if (uiCreateForm.rain_sensor) {
        createForm.rain_sensor = 'yes';
    }

    if (uiCreateForm.rear_door_lock) {
        createForm.rear_door_lock = 'yes';
    }

    if (uiCreateForm.rear_parking_sensors) {
        createForm.rear_parking_sensors = 'yes';
    }

    if (uiCreateForm.rear_view_camera) {
        createForm.rear_view_camera = 'yes';
    }

    if (uiCreateForm.roof_rails) {
        createForm.roof_rails = 'yes';
    }

    if (uiCreateForm.running_lights) {
        createForm.running_lights = 'yes';
    }

    if (uiCreateForm.safety_shutters) {
        createForm.safety_shutters = 'yes';
    }

    if (uiCreateForm.seat_ventilation) {
        createForm.seat_ventilation = 'yes';
    }

    if (uiCreateForm.side_airbags) {
        createForm.side_airbags = 'yes';
    }

    if (uiCreateForm.signalling) {
        createForm.signalling = 'yes';
    }

    if (uiCreateForm.smart_key) {
        createForm.smart_key = 'yes';
    }

    if (uiCreateForm.socket_12v) {
        createForm.socket_12v = 'yes';
    }

    if (uiCreateForm.socket_220v) {
        createForm.socket_220v = 'yes';
    }

    if (uiCreateForm.steering_wheel !== undefined) {
        createForm.steering_wheel = uiCreateForm.steering_wheel;
    }

    if (uiCreateForm.tcs) {
        createForm.tcs = 'yes';
    }

    if (uiCreateForm.tire_pressure_monitoring) {
        createForm.tire_pressure_monitoring = 'yes';
    }

    if (uiCreateForm.usb) {
        createForm.usb = 'yes';
    }

    if (uiCreateForm.wheels_material !== undefined) {
        createForm.wheels_material = uiCreateForm.wheels_material;
    }

    if (uiCreateForm.wheels_size !== undefined) {
        createForm.wheels_size = uiCreateForm.wheels_size;
    }

    return createForm;
}

export function mapComplectationUICreateFormToRequestCreateForm(uiCreateForm: ComplectationUICreateForm): ComplectationCreateForm {
    return {
        model_id: uiCreateForm.model_id,
        code: uiCreateForm.code,
        complectation_option: mapComplectationOptionsUICreateFormToRequestCreateForm(uiCreateForm.complectation_option),
    };
}
